var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"hamburger hamburger--collapse-r focus:outline-none",class:{'is-active':_vm.active},attrs:{"type":"button"},on:{"click":_vm.toggle}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"hamburger-box"},[_c('span',{staticClass:"hamburger-inner"})])
}]

export { render, staticRenderFns }